/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 加密模式：GCM/CBC/ECB/CTR/OFB/CFB（可选，默认GCM）
 */
export const PostTextAesEncryptAdvancedMode = {
  Gcm: "GCM",
  Cbc: "CBC",
  Ecb: "ECB",
  Ctr: "CTR",
  Ofb: "OFB",
  Cfb: "CFB",
} as const;
/**
 * 加密模式：GCM/CBC/ECB/CTR/OFB/CFB（可选，默认GCM）
 */
export type PostTextAesEncryptAdvancedMode = ClosedEnum<
  typeof PostTextAesEncryptAdvancedMode
>;

export const PostTextAesEncryptAdvancedMode$zodSchema = z.enum([
  "GCM",
  "CBC",
  "ECB",
  "CTR",
  "OFB",
  "CFB",
]).describe("加密模式：GCM/CBC/ECB/CTR/OFB/CFB（可选，默认GCM）");

/**
 * 填充方式：PKCS7/ZERO/NONE（可选，默认PKCS7）
 */
export const PostTextAesEncryptAdvancedPadding = {
  Pkcs7: "PKCS7",
  Zero: "ZERO",
  None: "NONE",
} as const;
/**
 * 填充方式：PKCS7/ZERO/NONE（可选，默认PKCS7）
 */
export type PostTextAesEncryptAdvancedPadding = ClosedEnum<
  typeof PostTextAesEncryptAdvancedPadding
>;

export const PostTextAesEncryptAdvancedPadding$zodSchema = z.enum([
  "PKCS7",
  "ZERO",
  "NONE",
]).describe("填充方式：PKCS7/ZERO/NONE（可选，默认PKCS7）");

/**
 * 输出格式：base64（默认）或hex
 */
export const OutputFormat = {
  Base64: "base64",
  Hex: "hex",
} as const;
/**
 * 输出格式：base64（默认）或hex
 */
export type OutputFormat = ClosedEnum<typeof OutputFormat>;

export const OutputFormat$zodSchema = z.enum([
  "base64",
  "hex",
]).describe("输出格式：base64（默认）或hex");

/**
 * 包含加密配置的JSON对象
 */
export type PostTextAesEncryptAdvancedRequest = {
  text: string;
  key: string;
  mode?: PostTextAesEncryptAdvancedMode | undefined;
  padding?: PostTextAesEncryptAdvancedPadding | undefined;
  iv?: string | undefined;
  output_format?: OutputFormat | undefined;
};

export const PostTextAesEncryptAdvancedRequest$zodSchema: z.ZodType<
  PostTextAesEncryptAdvancedRequest
> = z.object({
  iv: z.string().optional(),
  key: z.string(),
  mode: PostTextAesEncryptAdvancedMode$zodSchema.optional(),
  output_format: OutputFormat$zodSchema.optional(),
  padding: PostTextAesEncryptAdvancedPadding$zodSchema.optional(),
  text: z.string(),
}).describe("包含加密配置的JSON对象");

/**
 * 无效的请求参数
 */
export type PostTextAesEncryptAdvancedBadRequestResponseBody = {
  error?: string | undefined;
};

export const PostTextAesEncryptAdvancedBadRequestResponseBody$zodSchema:
  z.ZodType<PostTextAesEncryptAdvancedBadRequestResponseBody> = z.object({
    error: z.string().optional(),
  }).describe("无效的请求参数");

/**
 * 加密成功，返回密文和加密配置
 */
export type PostTextAesEncryptAdvancedResponseBody = {
  ciphertext?: string | undefined;
  mode?: string | undefined;
  padding?: string | undefined;
  iv?: string | undefined;
};

export const PostTextAesEncryptAdvancedResponseBody$zodSchema: z.ZodType<
  PostTextAesEncryptAdvancedResponseBody
> = z.object({
  ciphertext: z.string().optional(),
  iv: z.string().optional(),
  mode: z.string().optional(),
  padding: z.string().optional(),
}).describe("加密成功，返回密文和加密配置");

export type PostTextAesEncryptAdvancedResponse =
  | PostTextAesEncryptAdvancedResponseBody
  | PostTextAesEncryptAdvancedBadRequestResponseBody;

export const PostTextAesEncryptAdvancedResponse$zodSchema: z.ZodType<
  PostTextAesEncryptAdvancedResponse
> = z.union([
  z.lazy(() => PostTextAesEncryptAdvancedResponseBody$zodSchema),
  z.lazy(() => PostTextAesEncryptAdvancedBadRequestResponseBody$zodSchema),
]);
